export const INIT_SIGN = 'INIT_SIGN';
export const ADD_SIGNERS = 'ADD_SIGNERS';


